import { render, staticRenderFns } from "./TextResponse.vue?vue&type=template&id=a0fdb15e&scoped=true&"
import script from "./TextResponse.vue?vue&type=script&lang=js&"
export * from "./TextResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fdb15e",
  null
  
)

export default component.exports